export function optional(f) {
  return f == null ? null : required(f);
}

export function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/accessors.js
// module id = 287
// module chunks = 0